module.exports = __webpack_public_path__ + "static/media/EmailSocial.dbf25ef4.svg";